import styled from 'styled-components';
import { Media } from '../../../../styles/media';

const { tabletUp } = Media;

export const Container = styled.div`
  width: 100%;
  max-width: 630px;
  margin: 0 auto;
  margin-top: 40px;

  ${tabletUp`
    margin-top: 48px;
  `};
`;

export const FooterMenuContainer = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;

  ${tabletUp`
    justify-content: center;
  `};

  > li {
    padding-right: 10px;
    margin-bottom: 8px;
    margin-right: 10px;
    border-right: 1px solid ${({ theme }) => theme.lighterGray};
    a {
      font-weight: 400;
    }
  }

  > li:last-of-type {
    border: none;
  }
`;
